module.exports = __webpack_public_path__ + "img/df4e1a2.jpg";